const MCP_AUTHORIZATION_REDIRECT_STORAGE_KEY = 'solvace.mcpAuthorizationRedirect';

export function persistMcpAuthorizationRedirect(redirectUrl: string | null): void {
  if (!isMcpAuthorizationRedirect(redirectUrl)) return;

  try {
    sessionStorage.setItem(MCP_AUTHORIZATION_REDIRECT_STORAGE_KEY, redirectUrl);
  } catch {
    // The query parameter still handles non-SSO login when storage is unavailable.
  }
}

export function takeMcpAuthorizationRedirect(): string | null {
  try {
    const redirectUrl = sessionStorage.getItem(MCP_AUTHORIZATION_REDIRECT_STORAGE_KEY);
    sessionStorage.removeItem(MCP_AUTHORIZATION_REDIRECT_STORAGE_KEY);
    return isMcpAuthorizationRedirect(redirectUrl) ? redirectUrl : null;
  } catch {
    return null;
  }
}

function isMcpAuthorizationRedirect(redirectUrl: string | null): redirectUrl is string {
  if (!redirectUrl) return false;

  const [path, query = ''] = redirectUrl.split('?', 2);
  return path === '/mcp-authorize' && new URLSearchParams(query).has('session');
}
